import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ViewToggleService {
  private readonly STORAGE_KEY = 'nunciatura_view_preference';
  private isListVisibleSubject = new BehaviorSubject<boolean>(false);
  isListVisible$ = this.isListVisibleSubject.asObservable();

  constructor() {
    // Restaura a preferência salva ou usa o valor padrão
    this.restoreViewPreference();
  }

  private restoreViewPreference(): void {
    try {
      const savedPreference = localStorage.getItem(this.STORAGE_KEY);
      if (savedPreference !== null) {
        const isListVisible = JSON.parse(savedPreference);
        this.isListVisibleSubject.next(isListVisible);
      } else {
        this.isListVisibleSubject.next(false); // Começa com tabela por padrão
      }
    } catch (error) {
      this.isListVisibleSubject.next(false); // Começa com tabela por padrão
    }
  }

  private saveViewPreference(isListVisible: boolean): void {
    try {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(isListVisible));
    } catch (error) {
      console.warn('Erro ao salvar preferência de visualização:', error);
    }
  }

  toggleView() {
    const currentValue = this.isListVisibleSubject.value;
    const newValue = !currentValue;
    this.isListVisibleSubject.next(newValue);
    this.saveViewPreference(newValue);
  }

  setView(isVisible: boolean) {
    this.isListVisibleSubject.next(isVisible);
    this.saveViewPreference(isVisible);
  }

  isMobile(): boolean {
    return window.innerWidth < 768;
  }
}
